import { AWS_API_URL } from 'global/environment';
import { authorize, postRequest } from 'utils/http';
import { mapTimeProfilesToSchedules } from '../mapData';

export async function createTimeProfilesAPI(timeProfile) {
  const url = `${AWS_API_URL}/2n/time-profiles`;

  const payloadSchedules = timeProfile && Array.isArray(timeProfile.timeProfiles)
    ? mapTimeProfilesToSchedules(timeProfile.timeProfiles)
    : {};

  return postRequest(url, {
    data: {
      Name: timeProfile && timeProfile.name,
      ...payloadSchedules,
    },
  }, await authorize());
}
